<template>
    <div class="pagebox">
        <!-- 顶部 -->
        <PHeader></PHeader>

        <!-- 信息区域 -->
        <div class="wish_table">
            <div class="wish_box">
                <!-- <div class="mark">
                    <span>注：以下志愿表为模拟填报志愿表，正式填报请登录省考试院指定填报网站</span>
                    <span>申明：使用当年招生计划和参考历年录取数据的志愿模拟填报平台，参考数据均来自省考试院，正式填报过程中如遇到数据错误，请参阅省考试院发布的相关招生计划书籍</span>
                </div> -->
                <div class="userbox">
                    <div class="uleftbox">
                        <div class="type">
                            <div class="tname">评估报告：{{EvaluateZYData.WishName}}</div>
                            <div class="yname">{{EvaluateZYData.ExamYear}}年 {{EvaluateZYData.ExamProvinceName}}</div>
                        </div>
                        <div class="info">
                            <div class="exam">
                                <span>我的成绩：{{EvaluateZYData.Score}} 分</span>
                                <span class="rank">
                                    <span v-if="EvaluateZYData.Rank" class="s">
                                        {{ `位次: ${EvaluateZYData.Rank||'-'}` }}
                                    </span>
                                    <span v-else-if="EvaluateZYData.RankHigh || EvaluateZYData.RankLow" class="s">
                                        {{ `位次：${EvaluateZYData.RankHigh} - ${EvaluateZYData.RankLow}` }}
                                    </span>
                                </span>
                            </div>
                            <div class="exam">
                                <span v-if="EvaluateZYData.SubjectType==1||EvaluateZYData.SubjectType==2">
                                    <span class="area">首选:{{EvaluateZYData.SubjectType==1?'物理':'历史'}}</span>
                                    <span v-if="EvaluateZYData.Subjects" class="area">再选:{{EvaluateZYData.Subjects}}</span>
                                </span>
                                <span v-else-if="EvaluateZYData.SubjectType==3||EvaluateZYData.SubjectType==4">
                                    <span class="area">{{EvaluateZYData.SubjectType==3?'理科':'文科'}}</span>
                                </span>
                                <span v-else>
                                    <span v-if="EvaluateZYData.Subjects" class="area">{{EvaluateZYData.Subjects}}</span>
                                </span>
                                <span>批次：{{EvaluateZYData.BatchName}}</span>
                            </div>
                        </div>
                        <div class="marks">
                            <span>评估等级：<span :class="'c'+EvaluateZYData.EvaluateLevelNum">{{EvaluateZYData.EvaluateLevelName}}</span></span>
                            <span style="margin-left:20px;">评估得分：{{EvaluateZYData.EvaluateScore}}</span>
                        </div>
                    </div>
                    <div class="urightbox">
                        <div class="scoremark">
                            <div class="tt">成绩解读：</div>
                            <div class="tb">
                                <div class="xx">同分人数</div>
                                <div class="nn">{{EvaluateZYData.ScorePersons}} 人</div>
                            </div>
                            <div class="tb">
                                <div class="xx">排名区间</div>
                                <div class="nn">第 {{EvaluateZYData.RankHigh}}-{{EvaluateZYData.RankLow}} 名</div>
                            </div>
                            <div class="tb">
                                <div class="xx">超越考生</div>
                                <div class="nn">{{EvaluateZYData.RankPercent?(100-EvaluateZYData.RankPercent).toFixed(2):0}} %</div>
                            </div>
                        </div>
                        <div class="scorechat" id="Chat_Score"></div>
                        <div class="clear"></div>
                    </div>
                    <div class="clear"></div>
                </div>
                
                <div class="con_box">
                    <div class="ctit"><i class="iconfont">&#xec66;</i> 梯度对比</div>
                    <div class="cbox">
                        <div class="chatbox" id="Chat_Score2"></div>
                        <table class="chatlist" cellspacing="0">
                            <thead>
                                <tr>
                                    <td>区间</td>
                                    <td>推荐数量</td>
                                    <td>当前数量</td>
                                    <td>差额</td>
                                    <td>解读</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in EvaluateZYData.RecommendGroupList" :key="index">
                                    <td>{{item.RecommendGroupName}}</td>
                                    <td>{{item.RecommendCount}}</td>
                                    <td>{{item.Count}}</td>
                                    <td>{{item.Diff}}</td>
                                    <td>{{item.Remark}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="con_box">
                    <div class="ctit"><i class="iconfont">&#xe644;</i> 录取解读</div>
                    <div class="cbox">
                        <div class="htxt">
                            根据当前志愿填报顺序，您最有可能被以下{{CollegeOrMajorGroupId==1?('院校'+((EvaluateZYData.SubjectType==3||EvaluateZYData.SubjectType==4)?'':'专业组')):'专业'}}录取
                        </div>
                        <!-- 志愿列表（院校+专业） -->
                        <table class="possiblelist" cellspacing="0" v-if="CollegeOrMajorGroupId==1&&(EvaluateZYData.AdmisionPossibleList||[]).length>0">
                            <thead>
                                <tr>
                                    <td style="width:450px;">院校</td>
                                    <td colspan="4" style="width:calc(100% - 450px);">
                                        <div>
                                            <div style="width:calc(100% /  4);display:inline-block;">历年录取</div>
                                            <div style="width:calc(100% /  4);display:inline-block;">{{EvaluateZYData.YearList[0]}}</div>
                                            <div style="width:calc(100% /  4);display:inline-block;">{{EvaluateZYData.YearList[1]}}</div>
                                            <div style="width:calc(100% /  4);display:inline-block;">{{EvaluateZYData.YearList[2]}}</div>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in EvaluateZYData.AdmisionPossibleList" :key="index">
                                    <td style="width:450px;">{{item.CollegeName}}<span v-if="item.GroupCode">[{{item.GroupCode}}]</span></td>
                                    <td colspan="4" style="width:calc(100% - 450px);">
                                        <table cellspacing="0" class="yearbox">
                                            <tr>
                                                <td style="border-bottom-left-radius:0px;width:calc(100% /  4);">最低分</td>
                                                <td>{{item.ScoreLowOfYear1}}</td>
                                                <td>{{item.ScoreLowOfYear2}}</td>
                                                <td style="border-bottom-right-radius:0px;">{{item.ScoreLowOfYear3}}</td>
                                            </tr>
                                            <tr>
                                                <td style="border-bottom-left-radius:0px;">最低位次</td>
                                                <td>{{item.RankLowOfYear1}}</td>
                                                <td>{{item.RankLowOfYear2}}</td>
                                                <td style="border-bottom-right-radius:0px;">{{item.RankLowOfYear3}}</td>
                                            </tr>
                                            <tr>
                                                <td style="border-bottom-left-radius:0px;">等效分差</td>
                                                <td>{{item.PersonalScoreDiffOfYear1}}</td>
                                                <td>{{item.PersonalScoreDiffOfYear2}}</td>
                                                <td style="border-bottom-right-radius:0px;">{{item.PersonalScoreDiffOfYear3}}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <!-- 志愿列表（专业+院校） -->
                        <table class="possiblelist" cellspacing="0" v-else-if="CollegeOrMajorGroupId==2&&(EvaluateZYData.AdmisionPossibleList||[]).length>0">
                            <thead>
                                <tr>
                                    <td style="width:450px;">专业</td>
                                    <td colspan="4" style="width:calc(100% - 450px);">
                                        <div>
                                            <div style="width:calc(100% /  4);display:inline-block;">历年录取</div>
                                            <div style="width:calc(100% /  4);display:inline-block;">{{EvaluateZYData.YearList[0]}}</div>
                                            <div style="width:calc(100% /  4);display:inline-block;">{{EvaluateZYData.YearList[1]}}</div>
                                            <div style="width:calc(100% /  4);display:inline-block;">{{EvaluateZYData.YearList[2]}}</div>
                                        </div>
                                    </td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in EvaluateZYData.AdmisionPossibleList" :key="index">
                                    <td style="width:450px;">
                                        <div>{{item.MajorName}}<span v-if="item.MajorCode"> [{{item.MajorCode}}]</span></div>
                                    
                                        <div style="font-size:12px;">{{item.CollegeName}}<span v-if="item.CollegeCode"> [{{item.CollegeCode}}]</span></div>
                                    </td>
                                    <td colspan="4" style="width:calc(100% - 450px);">
                                        <table cellspacing="0" class="yearbox">
                                            <tr>
                                                <td style="border-bottom-left-radius:0px;width:calc(100% /  4);">最低分</td>
                                                <td>{{item.ScoreLowOfYear1}}</td>
                                                <td>{{item.ScoreLowOfYear2}}</td>
                                                <td style="border-bottom-right-radius:0px;">{{item.ScoreLowOfYear3}}</td>
                                            </tr>
                                            <tr>
                                                <td style="border-bottom-left-radius:0px;">最低位次</td>
                                                <td>{{item.RankLowOfYear1}}</td>
                                                <td>{{item.RankLowOfYear2}}</td>
                                                <td style="border-bottom-right-radius:0px;">{{item.RankLowOfYear3}}</td>
                                            </tr>
                                            <tr>
                                                <td style="border-bottom-left-radius:0px;">等效分差</td>
                                                <td>{{item.PersonalScoreDiffOfYear1}}</td>
                                                <td>{{item.PersonalScoreDiffOfYear2}}</td>
                                                <td style="border-bottom-right-radius:0px;">{{item.PersonalScoreDiffOfYear3}}</td>
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <div style="color:#666;font-size:16px;text-align:center;line-height:50px;" v-else>暂无数据！</div>
                    </div>
                </div>
                <div class="con_box">
                    <div class="ctit"><i class="iconfont">&#xe61a;</i> 志愿检查</div>
                    <div class="cbox">
                        <table class="jclist" cellspacing="0">
                            <thead>
                                <tr>
                                    <td>检查项</td>
                                    <td>检查内容</td>
                                    <td>检查结果</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item,index) in EvaluateZYData.CheckItemList" :key="index">
                                    <td>{{item.CheckItem}}</td>
                                    <td>
                                        <span>
                                            <span>{{item.CheckContent}}</span>
                                            <span v-if="item.ExceptList&&item.ExceptList.length>0">
                                                <span class="con" v-for="(it,ind) in item.ExceptList" :key="ind">{{it}}</span>
                                            </span>
                                        </span>
                                    </td>
                                    <td><span :class="item.CheckStatus==1?'t2':'t1'">{{item.CheckResult}}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="con_box">
                    <div class="ctit"><i class="iconfont">&#xe687;</i> 评估建议</div>
                    <div class="cbox">
                        <div class="htxt" style="margin:20px 0;" v-html="(EvaluateZYData.EvaluateCommment?EvaluateZYData.EvaluateCommment.replace(/(\n)/g, '<br/>'):'')">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <PFooter></PFooter>
    </div>
</template>
<script>
import PHeader from "@/components/Header.vue";
import PFooter from "@/components/Footer.vue";
import API from "@/api/config";
import { getStore } from "@/utils/utils";
export default {
    components:{
        PHeader,
        PFooter
    },
    data() {
        return{
            TableHeaderFixed:'',
            CollegeOrMajorGroupId:2,
            EvaluateZYData:{
                AdmisionPossibleList:[],
                YearList:[]
            }
        }
    },
    mounted(){
        this.CollegeOrMajorGroupId = (this.$route.query.ZYWay==0?1:this.$route.query.ZYWay)//兼容老高考
        // 已填列表数据
        this.GetZYEvaluateReport();
    },
    methods:{
        GetZYEvaluateReport(){
            API.Personal.GetZYEvaluateReport({Id:this.$route.query.WishId}).then(res => {
                if (res.Code==0&&res.Data) {
                    this.EvaluateZYData = res.Data;
                    let finalData = res.Data.ScoreRankList.map(item => {
                        return [
                            item.Score,
                            item.Persons
                        ]
                    });
                    let finalData2 = res.Data.ScoreGradientList.map(item => {
                        return [
                            item.Item,
                            item.Score
                        ]
                    });
                    setTimeout(() => {
                        this.GetChatScore(finalData);
                        this.GetChatScore2(finalData2);
					}, 200);
                }
            });
        },
        GetChatScore(data){
            // 初始化饼图配置
            let OEcharts = this.$echarts.init(document.getElementById('Chat_Score'))
            let option = {
                title: {
                    // text: '折现展示数据'
                },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    textStyle: {
                        color: '#ffffff'
                    },
                    formatter(params) { // 返回series配置项中的对应数据
                        return '当前：' + params[0].data[0] + '分， ' + params[0].data[1] + '人' + '<br />'
                    }
                },
                legend: {
                    
                },
                xAxis: [{
                    type: "category",
                    name: '分',
                    nameTextStyle:{
                        color:"#222"
                    },
                    
                }],
                yAxis: [{
                    type: "value",
                    name: '人数',
                    nameTextStyle:{
                        color:"#222"
                    },
                }],
                series: [{
                    type: 'line',
                    data: data,
                    showSymbol: false,
                    // lineStyle: {
                    //     width: 1.5
                    // },
                    // emphasis: {
                    //     lineStyle: {
                    //         width: 1.5
                    //     }
                    // },
                    // color:"#fff"
                }],
            }
            OEcharts.setOption(option)
        },
        GetChatScore2(data){
            // 初始化饼图配置
            let OEcharts = this.$echarts.init(document.getElementById('Chat_Score2'))
            let option = {
                title: {
                    // text: '折现展示数据'
                },
                tooltip: {
                    show: true,
                    trigger: 'axis',
                    backgroundColor: 'rgba(0,0,0,0.6)',
                    textStyle: {
                        color: '#ffffff'
                    },
                    formatter(params) { // 返回series配置项中的对应数据
                        return '当前：志愿' + params[0].data[0] + '， '  + '分差'+ params[0].data[1] + '<br />'
                    }
                },
                legend: {
                    
                },
                xAxis: [{
                    type: "category",
                    // name: '分数',
                    nameTextStyle:{
                        color:"#222"
                    },
                    
                }],
                yAxis: [{
                    type: "value",
                    // name: '人数',
                    nameTextStyle:{
                        color:"#222"
                    },
                }],
                series: [{
                    type: 'line',
                    data: data,
                    showSymbol: false,
                    // lineStyle: {
                    //     width: 1.5
                    // },
                    // emphasis: {
                    //     lineStyle: {
                    //         width: 1.5
                    //     }
                    // },
                    // color:"#fff"
                }],
            }
            OEcharts.setOption(option)
        }
    }
}
</script>
<style scoped lang="less">
.wish_table{
    max-width: 1420px;
    margin: 20px auto 0px;
    user-select: none;
    .wish_box{
        margin: 0px 20px;
        border: 1px solid #dfdddd;
        margin-bottom: 20px;
        border-radius: 5px;
        padding-bottom: 10px;
        .mark{
            border: 1px dashed rgba(var(--themecolor),0.6);
            border-radius: 5px;
            padding: 5px 0;
            margin: 15px;
            background-color: #fff;
            span{
                display: inline-block;
                margin: 3px 15px;
                color: #777;
                font-size: 13px;
            }
        }
        .userbox{
            margin: 20px 20px 10px;
            background-color: #fff;
            border-radius: 5px;
            .uleftbox{
                width: calc(100% - 700px);
                float: left;
            }
            .urightbox{
                width: 700px;
                float: left;
                border-radius: 5px;
                margin: 20px 0;
                overflow: hidden;
                .scoremark{
                    width: 249px;
                    float: left;
                    border: 1px solid #ddd;
                    border-right: none;
                    height: 248px;
                    border-top-left-radius: 5px;
                    border-bottom-left-radius: 5px;
                    background-color: #d0ebe0;
                    .tt{
                        font-size: 16px;
                        color: #222;
                        margin-top: 20px;
                        margin-left: 15px;
                    }
                    .tb{
                        color: #555;
                        font-size: 14px;
                        margin-top: 15px;
                        margin-left: 15px;
                        .xx{
                            color: #666;
                        }
                        .nn{
                            color: #222;
                            margin-top: 5px;
                        }
                    }
                }
                .scorechat{
                    width: 429px;
                    float: left;
                    // background-color: rgba(var(--themecolor),0.15);
                    height: 248px;
                    margin-right: 20px;
                    border-top-right-radius: 5px;
                    border-bottom-right-radius: 5px;
                    border: 1px solid #ddd;
                    border-left: none
                }
            }
            .type{
                padding: 30px 20px 0;
                .tname{
                    font-size: 24px;
                    color: #555;
                    span{
                        color: #666;
                    }
                }
                .yname{
                    font-size: 18px;
                    color: #555;
                    margin-top: 30px;
                }
            }
            .info{
                margin: 20px 20px 20px;
                .exam{
                    font-size: 16px;
                    color: #555;
                    margin-top: 10px;
                    span{
                        margin-right: 20px;
                    }
                }
            }
            .marks{
                color: #777;
                font-size: 20px;
                line-height: 20px;
                margin: 40px 20px 20px;
                .c1{
                    color: #04a835;
                }
                .c2{
                    color: #4ea804;
                }
                .c3{
                    color: #a77a00;
                }
                .c4{
                    color: #b30404;
                }
            }
        }
        .con_box{
            margin: 20px 20px 10px;
            background-color: #fff;
            border-radius: 5px;
            overflow: hidden;
            box-shadow: 0px 2px 10px 1px #d0ebe0;
            .ctit{
                width: 100%;
                height: 40px;
                line-height: 40px;
                color: #555;
                font-size: 16px;
                background-color: #d0ebe0;
                text-indent: 10px;
                i{
                    color: rgba(var(--themecolor), 1);
                }
            }
            .cbox{
                width: 100%;
                .chatbox{
                    width: 100%;
                    height: 250px;
                    background-color: #fff;
                }
                .chatlist{
                    width: 100%;
                    thead{
                        width: 100%;
                        height: 50px;
                        line-height: 50px;
                        color: #333;
                        font-size: 15px;
                        text-align: center;
                        background-color: #eeeeee;
                    }
                    tbody{
                        width: 100%;
                        tr{
                            height: 40px;
                            line-height: 40px;
                            color: #555;
                            font-size: 15px;
                            text-align: center;
                            border-left: 1px solid #e2e2e2;
                            td{
                                border: 1px solid #e2e2e2;
                                border-left: none;
                                border-top: none;
                                width: calc(100% / 5);
                            }
                            td:first-child{
                                border-left: 1px solid #e2e2e2;
                            }
                        }
                        tr:last-child{
                            td:first-child{
                                border-bottom-left-radius: 5px;
                                border-left: 1px solid #e2e2e2;
                            }
                        }
                        tr:last-child{
                            td:last-child{
                                border-bottom-right-radius: 5px;
                            }
                        }
                        tr:nth-child(2n){
                            background-color: #faf9f9;
                        }
                    }
                }
                .possiblelist{
                    width: 100%;
                    thead{
                        width: 100%;
                        height: 50px;
                        line-height: 50px;
                        color: #333;
                        font-size: 15px;
                        text-align: center;
                        background-color: #eeeeee;
                    }
                    tbody{
                        width: 100%;
                        tr{
                            height: 40px;
                            line-height: 40px;
                            color: #555;
                            font-size: 15px;
                            text-align: center;
                            border-left: 1px solid #e2e2e2;
                            td{
                                border: 1px solid #e2e2e2;
                                border-left: none;
                                border-top: none;
                                width: calc(100% / 5);
                                .yearbox{
                                    width: 100%;
                                    tr{
                                        line-height: 20px;
                                        td{
                                            border-left: none;
                                            width: 50px;
                                        }
                                        td:last-child{
                                            border-right: none;
                                        }
                                        td:first-child{
                                            width: 60px;
                                            border-left: none;
                                        }
                                    }
                                    tr:last-child{
                                        td{
                                            border-bottom: none;
                                        }
                                        td:first-child{
                                            border-left: none;
                                            border-bottom-left-radius: 0 !important;
                                        }
                                        td:last-child{
                                            border-left: none;
                                        }
                                    }
                                }
                            }
                            td:first-child{
                                border-left: 1px solid #e2e2e2;
                            }
                        }
                        tr:last-child{
                            td:first-child{
                                border-bottom-left-radius: 5px;
                                border-left: 1px solid #e2e2e2;
                            }
                        }
                        tr:last-child{
                            td:last-child{
                                border-bottom-right-radius: 5px;
                            }
                        }
                    }
                }
                .htxt{
                    width: 100%;
                    color: rgba(var(--themecolor), 1);
                    font-size: 15px;
                    line-height: 22px;
                    padding: 15px 20px;
                }
                .jclist{
                    width: 100%;
                    thead{
                        width: 100%;
                        height: 50px;
                        line-height: 50px;
                        color: #333;
                        font-size: 15px;
                        text-align: center;
                        background-color: #eeeeee;
                    }
                    tbody{
                        width: 100%;
                        tr{
                            height: 40px;
                            line-height: 40px;
                            color: #555;
                            font-size: 15px;
                            text-align: center;
                            border-left: 1px solid #e2e2e2;
                            td{
                                border: 1px solid #e2e2e2;
                                border-left: none;
                                border-top: none;
                            }
                            td:first-child{
                                border-left: 1px solid #e2e2e2;
                                width: 200px;
                            }
                            td:nth-child(2){
                                width: calc(100% - 400px);
                                text-align: left;
                                span{
                                    display: block;
                                    margin: 12px 20px;
                                    line-height: 22px;
                                }
                            }
                            td:nth-child(3){
                                width: 200px;
                                .t1{
                                    color: #0eb366;
                                }
                                .t2{
                                    color: #df1a1a;
                                }
                            }
                        }
                        tr:last-child{
                            td:first-child{
                                border-bottom-left-radius: 5px;
                                border-left: 1px solid #e2e2e2;
                            }
                        }
                        tr:last-child{
                            td:last-child{
                                border-bottom-right-radius: 5px;
                            }
                        }
                        tr:nth-child(2n){
                            background-color: #faf9f9;
                        }
                    }
                }
            }
        }
    }
}
.wish_t_h{
    width: 100%;
    height: 50px;
    .wish_t_fixed{
        width: 100%;
        height: 50px;
        .wish_head{
            margin: auto;
            user-select: none;
            .htable{
                .head{
                    margin: 0px 20px;
                    background-color: #f5ecec;
                    height: 49px;
                    line-height: 49px;
                    color: #555;
                    font-size: 15px;
                    border-bottom: 1px solid #ddd;
                    border: 1px solid #ddd;
                    border-top-left-radius: 5px;
                    border-top-right-radius: 5px;
                    .td{
                        text-align: center;
                        border-left: 1px solid #ddd;
                        float: left;
                        .t{
                            border-bottom: 1px solid #ddd;
                            height: 24px;
                            line-height: 24px;
                        }
                        .year{
                            height: 25px;
                            line-height: 25px;
                            .y{
                                float: left;
                                width: calc((100% - 2px) / 3);
                                border-left: 1px solid #ddd;
                                font-size: 14px;
                                color: #777;
                            }
                            .y:first-child{
                                border-left:none;
                            }
                        }
                    }
                    .td:nth-child(1){
                        width: 50px;
                        border-left:none;
                    }
                    .td:nth-child(2){
                        width: 240px;
                    }
                    .td:nth-child(3){
                        width: 300px;
                    }
                    .td:nth-child(4){
                        width: 150px;
                    }
                    .td:nth-child(5){
                        width: calc(100% - 745px);
                    }
                }
                .majorgroup{
                    .td:nth-child(2){
                        width: 300px;
                    }
                    .td:nth-child(3){
                        width: 300px;
                    }
                    .td:nth-child(4){
                        width: 150px;
                    }
                    .td:nth-child(5){
                        width: calc(100% - 804px);
                    }
                }
            }
        }
    }
    .wish_t_fixed.fixed{
        position: fixed;
        top: 40px;
        left: 0px;
        z-index: 99;
    }
}
.wish_t_l{
    width: 100%;
    .wish_t_m{
        margin: auto;
        user-select: none;
        .wtable{
            margin: 0px 0px 20px;
            .table{
                margin: 0px 20px 20px;
                border: 1px solid #ddd;
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
                background-color: #fff;
                tr{
                    color: #666;
                    font-size: 14px;
                    td{
                        padding: 0 5px;
                        border-left: 1px solid #ddd;
                        border-bottom: 1px solid #ddd;
                        .c_name{
                            color: #555;
                            font-size: 20px;
                            line-height: 24px;
                        }
                        ._name_text:hover {
                            color: rgba(var(--themecolor), 0.9);
                            cursor: pointer;
                        }
                        .s_txt{
                            margin-top: 10px;
                            font-size: 12px;
                            span{
                                margin: 5px 5px;
                            }
                            .types{
                                font-size: 12px;
                                display: block;
                                line-height: 24px;
                            }
                            .tipss{
                                font-size: 12px;
                                color: #888;
                                margin-top: 5px;
                                overflow: hidden;
                                display: inline-block;
                                height: 20px;
                                span{
                                    padding: 0 5px;
                                    border-left: 1px solid #ddd;
                                    display: inline-block;
                                    height: 12px;
                                    line-height: 12px;
                                }
                                span:first-child{
                                    border-left:none;
                                    padding-left: 0;
                                }
                            }
                        }
                        .num{
                            display: inline-block;
                            height: 18px;
                            text-align: center;
                            line-height: 18px;
                            color: #666;
                            font-size: 14px;
                            i{
                                font-size: 12px;
                                color: #999;
                                margin-left: 2px;
                            }
                        }
                        .major{
                            padding: 10px 10px;
                            .name{
                                color: #555;
                                font-size: 18px;
                                line-height: 22px;
                                margin-bottom: 5px;
                            }
                            ._name_text:hover {
                                color: rgba(var(--themecolor), 0.9);
                                cursor: pointer;
                            }
                            .mx{
                                font-size: 12px;
                                margin: 5px 0;
                                span{
                                    margin-right:10px;
                                }
                                .sbtips{
                                    display: inline-block;
                                    padding: 2px 5px;
                                    color: #3e80b9;
                                    background-color: #c8e4f4;
                                    font-size: 12px;
                                    border-radius: 3px;
                                    margin-left: 5px;
                                }
                            }

                        }
                        .score{
                            font-size: 14px;
                            color: rgba(var(--themecolor),1);
                            display: block;
                            .isadjuststr{
                                margin-left: 10px;
                                font-size: 12px;
                                color: #666;
                            }
                            .tp{
                                display: inline-block;
                                width: 16px;
                                height: 16px;
                                border-radius: 16px;
                                font-size: 14px;
                                color: #fff;
                                text-align: center;
                                line-height: 16px;
                                margin-right: 5px;
                            }
                            .tp.c{
                                background-color: #d63434;
                            }
                            .tp.w{
                                background-color: #ec8a20;
                            }
                            .tp.b{
                                background-color: #1ebb72;
                            }
                        }
                    }
                    td:nth-child(1){
                        width: 40px;
                        border-left:none;
                        text-align: center;
                        position: relative;
                        
                    }
                    td:nth-child(2){
                        width: 240px;
                        text-align: center;
                        padding: 5px 0;
                    }
                    td:nth-child(3){
                        padding: 0;
                        tr:last-child td{
                            border-bottom:none;
                        }
                        td{
                            border-bottom: 1px solid #ddd;
                            .person{
                                color: #777;
                                font-size: 12px;
                                margin-bottom: 10px;
                                span{
                                    color: #555;
                                    font-size: 18px;
                                }
                            }
                            .md{
                                color: #888;
                                font-size: 12px;
                            }
                        }
                        td:nth-child(1){
                            width: 290px;
                        }
                        td:nth-child(2){
                            width: 150px;
                            border-left: 1px dashed #b8b8b8;
                        }
                        td:nth-child(3){
                            border-left: 1px dashed #b8b8b8;
                            padding: 20px 0;
                            .ls{
                                width: calc((100% - 2px) / 3);
                                display: inline-block;
                                border-left: 1px dashed #b8b8b8;
                                span{
                                    display: block;
                                    line-height: 20px;
                                    text-align: center;
                                    color: #666;
                                    font-size: 12px;
                                }
                            }
                            .ls:first-child{
                                border-left:none;
                            }

                            .tips {
                                display: flex;
                                span {
                                    display: inline;
                                }
                            }
                            .tips-text {
                                position: relative;
                                .icon {
                                    height: 13px;
                                    color: #999;
                                }
                                &:hover {
                                    cursor: default;
                                    .show-text {
                                        display: block;
                                        cursor: default;
                                        text-align: left;
                                    }
                                }
                                .show-text {
                                    display: none;
                                    width: 200px;
                                    padding: 5px;
                                    border-radius: 5px;
                                    background-color: rgba(0,0,0,0.5);
                                    color: #fff;
                                    position: absolute;
                                    top: -88px;
                                    left: -100px;
                                    z-index: 2;
                                }
                            }
                            
                        }
                    }
                }
                tr:last-child td{
                    border-bottom:none;
                }
            }
            .majorgroup{
                tr td{
                    text-align: center;
                    .person{
                        color: #777;
                        font-size: 12px;
                        margin-bottom: 10px;
                        span{
                            color: #555;
                            font-size: 18px;
                        }
                    }
                    .md{
                        color: #888;
                        font-size: 12px;
                    }
                    .score{
                        font-size: 14px;
                        color: rgba(var(--themecolor),1);
                        display: block;
                    }
                }
                tr td:nth-child(2){
                    width: 300px;
                }
                tr td:nth-child(3){
                    width: 280px;
                    padding: 0px 10px;
                }
                tr td:nth-child(4){
                    width: 140px;
                }
                tr td:nth-child(5){
                    padding: 10px 0;
                    .ls{
                        width: calc((100% - 2px) / 3);
                        display: inline-block;
                        border-left: 1px dashed #b8b8b8;
                        span{
                            display: block;
                            line-height: 20px;
                            text-align: center;
                            color: #666;
                            font-size: 12px;
                        }
                    }
                    .ls:first-child{
                        border-left:none;
                    }
                    .tips {
                        display: flex;
                        span {
                            display: inline;
                        }
                    }
                    .tips-text {
                        position: relative;
                        .icon {
                            height: 13px;
                            color: #999;
                        }
                        &:hover {
                            cursor: default;
                            .show-text {
                                display: block;
                                cursor: default;
                            }
                        }
                        .show-text {
                            display: none;
                            width: 200px;
                            padding: 5px;
                            border-radius: 5px;
                            background-color: rgba(0,0,0,0.5);
                            color: #fff;
                            position: absolute;
                            top: -88px;
                            left: -100px;
                            z-index: 2;
                        }
                    }
                }
            }
            .nowish{
                width: 100%;
                text-align: center;
                line-height: 300px;
                color: #666;
                font-size: 16px;
            }
        }
    }
}
.tips-words {
    font-size: 12px;
    .question-text{
        position: relative;
        .icon{
            display: inline-block;
            width: 16px;
            cursor: pointer;
        }
        .text{
            display: none;
            width: 600px;
            padding: 5px;
            border-radius: 5px;
            background-color: rgba(0,0,0,0.7);
            color: #fff;
            position: absolute;
            top: 18px;
            left: -100px;
            z-index: 2;
            text-align: left;
        }
    }
    .question-text:hover{
        .text{
            display: block;
        }
    }
}
</style>
<style lang="less">
.el-message-box__wrapper .el-message-box .el-message-box__btns .el-button:focus, .el-message-box__wrapper .el-message-box .el-message-box__btns .el-button:hover {
  color: rgba(var(--themecolor),0.75) !important;
  border-color: rgba(var(--themecolor),0.35) !important;
  background-color: rgba(var(--themecolor),0.01) !important;
}
.el-message-box__wrapper .el-message-box .el-message-box__btns .el-button--primary{
    background-color: rgba(var(--themecolor),0.75) !important;
    border-color: rgba(var(--themecolor),0.75) !important;
}
.el-message-box__wrapper .el-message-box .el-message-box__btns .el-button--primary:focus,.el-message-box__wrapper .el-message-box .el-message-box__btns .el-button--primary:hover{
    background-color: rgba(var(--themecolor),0.95) !important;
    border-color: rgba(var(--themecolor),0.95) !important;
    color: #fff !important;
}
.el-message-box__wrapper .el-message-box .el-message-box__header .el-message-box__headerbtn .el-message-box__close:hover{
    color: rgba(var(--themecolor),0.95) !important;
}
.el-message-box__wrapper .el-message-box .el-input.is-active .el-input__inner,.el-message-box__wrapper .el-message-box .el-input__inner:focus{
    border-color: #ddd !important;
}
</style>